import {InventoryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import APIUtil from 'util/APIUtil';
import {assertNever} from 'util/Types';

export default function isStructuredTableSupportedForFile(
  kind: StructuredTableKind,
  fileId: string
): boolean {
  if (APIUtil.isBaseEntry(fileId) || APIUtil.isEntryOrSubOrWorkflowTemplate(fileId)) {
    switch (kind) {
      case StructuredTableKind.PLATE_CREATION:
        return isFeatureEnabled({feature: InventoryFeature.INVENTORY_CREATE});
      case StructuredTableKind.BOX_CREATION:
        return isFeatureEnabled({feature: InventoryFeature.INVENTORY_CREATE});
      case StructuredTableKind.LOOKUP:
        return true;
      case StructuredTableKind.RUN_OUTPUT_SAMPLES:
        return false;
      case StructuredTableKind.RESULTS:
        return false;
      case StructuredTableKind.MIXTURE_METADATA:
      case StructuredTableKind.MIXTURE_INGREDIENTS:
        // Neither of the mixture structured tables can ever be inserted directly into an entry
        return false;
      case StructuredTableKind.INVENTORY:
        return false;
      case StructuredTableKind.PARAMETER:
        // Parameter Tables can only be inserted into Recipe and procedure step document. Logic
        // lives in NoteToolBar to decide whether or not they can actually be inserted.
        return false;
      default:
        // @ts-expect-error TODO: add a case for REGISTRATION
        assertNever(kind);
        return false;
    }
  }

  return false;
}
